import dailyWages from "../components/views/dailywages/dailyWages.vue";
import dailyWagesCreate from "../components/views/dailywages/dailyWagesCreate.vue";

const routes = [
  {
    path: "dailywages",
    component: dailyWages,
    name: "dailywages",
    meta: {
      description: "List of Daily Wages",
      title: "Daily Wages",
      requiresAuth: true,
    },
  },
  {
    path: "dailywages/dailywagescreate/:_id",
    component: dailyWagesCreate,
    name: "dailywagescreate",
    meta: {
      // description: "Add a new Daily Wages",
      title: "Add / Update Daily Wages",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/dailywages.route.js